module.exports = __webpack_public_path__ + "img/kommune-612.af21e182.svg";